import React, { useEffect, useRef, useState } from "react";
import "./PlacesTopSection.scss";
import location_icon from "../../Images/location_icon.png";
import SearchIcon from "../../Images/search_icon.png";
import SearchIcon1 from "../../Images/search_icon1.png";
import { useFormik } from "formik";
import * as Yup from "yup";



const PlacesTopSection = ({handleSearchData}) => {
  const [loading, setLoading] = useState(false);
  const [mobileLocation, setMobileLocation] = useState("");
  const [mobileRestaurantName, setMobileRestaurantName] = useState("");
  const debounceTimer = useRef(null);
  const validateSchema = Yup.object().shape({
    location: Yup.string().notRequired(),
    restaurantName: Yup.string().notRequired()
  });

  const formik = useFormik({
    
    initialValues: {
      location: "",
      restaurantName: ""
    },
    
    validationSchema: validateSchema,
    onSubmit: (values, { resetForm }) => {
      
      let flag = true;
      if(values?.location != ""){
        flag = false;
      }
      if(values?.restaurantName != ""){
        flag = false;
      }
      if(!flag){
        setLoading(true);
        handleSearchData(values);
        window.scrollBy(0, 350);
        setTimeout(() => {
          window.scrollBy(0, 350); 
          setLoading(false);
          // resetForm();
        }, 1000 * 2);
      }
    },
  });
  const setSearchValueWithDebounce = () => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      let searchValueData = {
        location: mobileLocation,
        restaurantName: mobileRestaurantName
      };
      handleSearchData(searchValueData);
    }, 1000 * 2); // 2 seconds debounce time
  };

  useEffect(() => {
    setSearchValueWithDebounce();
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, [mobileLocation, mobileRestaurantName]);

  return (
    <div>
      <div className="places_header_main_wrapper">
        <div className="places_header_heading">
        Discover Dining Options, Just Around the Corner
        </div>
          <div className="desktop">
            <form  onSubmit={formik.handleSubmit}>
              <div className="places_searchbar_main_wrapper">
                <div className="places_searchbar_location_wrapper">
                  <div className="places_searchbar_location_icon_wrapper">
                    <img src={location_icon} />
                  </div>
                  <div className="places_searchbar_location_input_wrapper">
                    <input 
                      type="text" 
                      id="location"
                      name="location"
                      placeholder="Location"
                      onChange={formik.handleChange}
                      value={formik.values.location} 
                    />
                    {formik.touched.location && formik.errors.location ? (
                      <div id="error_msg">{formik.errors.location}</div>
                    ) : null}
                  </div>
                  <div className="break_line"></div>
                </div>

                <div className="places_searchbar_right_wrapper">
                  <div className="places_searchbar_right_search_wrapper">
                    {/* <div className="places_searchbar_right_search_image_wrapper">
                      <img src={SearchIcon} />
                    </div> */}
                    <div className="places_searchbar_right_search_name_wrapper">
                      <input 
                        type="text" 
                        id="restaurantName"
                        name="restaurantName"
                        placeholder="Restaurants name" 
                        onChange={formik.handleChange}
                        value={formik.values.restaurantName} 
                      />
                      {formik.touched.restaurantName && formik.errors.restaurantName ? (
                        <div id="error_msg">{formik.errors.restaurantName}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="places_searchbar_button_wrapper">
                    <div className="places_searchbar_button_image_wrapper">
                      <img src={SearchIcon1} />
                    </div>
                    <div className="places_searchbar_button_second_wrapper">
                      <button disabled={loading} type="submit">
                        {loading ? "Loading..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="mobile">
            <form  onSubmit={formik.handleSubmit}>            
                <div className="places_searchbar_main_wrapper">
                  <div className="places_searchbar_location_wrapper1">
                    <div className="places_searchbar_location_icon_wrapper1">
                      <img src={location_icon} />
                    </div>
                    <div className="places_searchbar_location_input_wrapper1">
                      <input 
                        type="text" 
                        id="location"
                        name="location"
                        placeholder="Location"
                        onChange={(e)=>{setMobileLocation(e.target.value)}}
                        value={mobileLocation} 
                      />
                    </div>
                  </div>
                </div>                
              <div className="places_searchbar_main_wrapper">
                <div className="places_searchbar_right_wrapper1">
                  <div className="places_searchbar_right_search_wrapper1">
                    <div className="places_searchbar_right_search_name_wrapper1">
                      <input 
                        type="text" 
                        id="restaurantName"
                        name="restaurantName"
                        placeholder="Restaurants name" 
                        onChange={(e)=>{setMobileRestaurantName(e.target.value)}}
                        value={mobileRestaurantName}
                      />
                      <div className="places_searchbar_right_search_image_wrapper1">
                        <img src={SearchIcon} />
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </form>
          </div>
      </div>
    </div>
  );
};

export default PlacesTopSection;
